import { PagingFilter } from '../../../shared/models/paging-filter.model';
import { PortfolioCustomerDetailsModel } from '../models/portfolio-customer-details-model';
import { PagingWrapper } from '../../../core/models/paging-wrapper';
import { PortfolioCustomerDetailsFilterModel } from '../models/portfolio-customer-details-filter-model';
import { PortfolioModel } from '../models/portfolio-model';
import { ServerValidationResult } from '../../../shared/validation/server-validation-result';
import { PortfolioAccountManagerAdminModel } from '../models/portfolio-account-manager-admin-model';
import { PortfolioAccountManagerModel } from '../models/portfolio-account-manager-model';
import { PortfolioAddModel } from '../models/portfolio-add-model';
import { Injectable } from '@angular/core';
import { UrlConfigContainer } from '../../../core/url-config';
import { UrlConfigService } from '@hrra/core';
import { AjaxDataServiceService } from '../../../core/ajax-data-service.service';
import { PortfolioListRecordModel } from '../models/portfolio-list-record-model';
import { EmptyData } from '../../../core/models/empty-data';
import { Observable } from 'rxjs';
import { NewAjaxDataServiceService } from '../../../core/new-ajax-data.service';
import { PortfolioSalesAssistant } from '../models/portfolio-sales-assistant.model';
import { ApiResponse } from '../../../core/api-response';

@Injectable()
export class PortfolioService {
  public getPortfolio(portfolioId: number): Observable<PortfolioModel> {
    let url = this.urlService.format(this.urlService.urlConfig.api.data.portfolios.get, {
      id: portfolioId,
    });
    return this.ajax.postData(
      url,
      { portfolioId: portfolioId.toString() },
      PortfolioModel
    );
  }

  public getAssistants(
    portfolioId: number
  ): Observable<ApiResponse<PortfolioSalesAssistant[]>> {
    let url = this.urlService.format(this.urlService.urlConfig.api.data.salesAssistants.list, {
      portfolioId: portfolioId,
    });
    return this.newAjax.postData<PortfolioSalesAssistant[]>(url, {});
  }

  public saveAssistant(portfolioId: number, adminId: number) {
    let data = {
      PortfolioId: portfolioId,
      AdminId: adminId,
    };
    let url = this.urlService.urlConfig.api.data.salesAssistants.save;
    return this.newAjax.postData(url, data);
  }

  public removeAssistant(portfolioSalesAssistantId: number) {
    let url = this.urlService.format(this.urlService.urlConfig.api.data.salesAssistants.delete, {
      portfolioSalesAssistantId: portfolioSalesAssistantId,
    });
    return this.newAjax.postData(url, {});
  }

  public listPortfolioCustomerDetails(
    portfolioId: number,
    filter: PagingFilter<PortfolioCustomerDetailsFilterModel>
  ): Observable<PagingWrapper<PortfolioCustomerDetailsModel>> {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.portfolios.details.list,
      { id: portfolioId }
    );
    // let data = {
    //   portfolioId: portfolioId.toString(),
    //   filter: filter.toObject(),
    // };
    let data = filter.toObject();
    return this.ajax.postDataPaging(url, data, PortfolioCustomerDetailsModel);
  }

  public getAccessiblePortfolios() {
    return this.newAjax.getData(
      this.urlService.urlConfig.api.data.transactions.getAccessiblePortfolios,
      {}
    );
  }

  public listPortfolios() {
    return this.ajax.getDataPaging(
      this.urlService.urlConfig.api.data.portfolios.list,
      {},
      PortfolioListRecordModel
    );
  }

  public getPortfolios() {
    return this.ajax.getDataPaging(
      this.urlService.urlConfig.api.data.portfolios.getList,
      {},
      PortfolioModel
    );
  }

  public listOwnPortfolios() {
    return this.ajax.getDataPaging(
      this.urlService.urlConfig.api.data.portfolios.listAdminPortfolios,
      {},
      PortfolioModel
    );
  }

  public moveCustomerToPortfolio(
    srcPortfolioId: number,
    destPortfolioId: number,
    customers: PortfolioCustomerDetailsModel[]
  ) {
    let data = {
      portfolioId: srcPortfolioId,
      destPortfolioId: destPortfolioId,
      customers: customers.map((c) => c.customerId),
    };
    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.portfolios.details.move,
      { id: srcPortfolioId }
    );
    return this.ajax.postData(url, data, EmptyData);
  }

  public createPortfolio(portfolioSubmitData: PortfolioAddModel) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.portfolios.save,
      portfolioSubmitData,
      EmptyData
    );
  }

  public accountManagerList() {
    return this.ajax.getDataPaging(
      this.urlService.urlConfig.api.data.portfolios.accountManagers.list,
      {},
      PortfolioAccountManagerAdminModel
    );
  }

  public getPortfolioHistory(portfolioId: number) {
    let url = this.urlService.format(this.urlService.urlConfig.api.data.portfolios.history.get, {
      id: portfolioId,
    });
    return this.ajax.postDataPaging(
      url,
      { portfolioId: portfolioId.toString() },
      PortfolioAccountManagerModel
    );
  }

  public savePortfolioAccountManager(
    newAccountManagerId: number,
    portfolio: PortfolioModel
  ) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.portfolios.accountManagers.save,
      {}
    );
    let data = {
      portfolio: portfolio.toObject(),
      accountManagerId: newAccountManagerId.toString(),
    };
    return this.ajax.postData(url, data, EmptyData);
  }

  public savePortfolioName(newName: string, portfolioId: number) {
    let url = this.urlService.format(this.urlService.urlConfig.api.data.portfolios.editName, {
      id: portfolioId,
    });
    let data = {
      portfolioId: portfolioId.toString(),
      name: newName.toString(),
    };
    return this.ajax.postData(url, data, EmptyData);
  }

  public validatePortfolioName(name: String) {
    let data = {
      name: name,
    };
    return this.ajax
      .postData(
        this.urlService.urlConfig.api.data.portfolios.validate,
        data,
        ServerValidationResult
      )
      .toPromise();
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>,
    private newAjax: NewAjaxDataServiceService
  ) {}
}
